import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  searchForRecentFood,
  searchForFood,
  uploadMealImage,
  searchWeeklyMeal,
  analyzeFoodImage,
} from "../../../../features/mobile/mealSlice";
import SearchDialog from "./SearchDialog";
import { ReactComponent as Search } from "../../../../svg/search.svg";
import Btn from "../common/Btn";
import { toast } from "react-toastify";
import toastCommonProps from "../../../../common/toast";

const FoodInputBox = ({ onSaveAddorEdit, mealType, mealDate }) => {
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const boxRef = useRef(null);
  const keywordRef = useRef(null);
  const fileInputRef = useRef(null);
  const [value, setValue] = useState(null);
  const [boxStatus, setBoxStatus] = useState("search"); //search 최근 입력한 음식, 검색한 음식, addQty 음식량 입력 후 완료
  const { loginInfo } = useSelector((state) => state.commonApp);
  const [noFoodOpen, setNoFoodOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [searchedFoodLists, setSearchedFoodLists] = useState([]); //비동기문제로 내부에서 데이터 담아줌
  const [previewImage, setPreviewImage] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [analysisResult, setAnalysisResult] = useState(null);
  console.log(searchedFoodLists, "searchedFoodLists");

  const onSearchForFood = () => {
    let params = { searchText: value, userId: loginInfo.userId };
    dispatch(searchForFood(params))
      .unwrap()
      .then((res) => {
        if (res.data.ok) {
          if (res.data.searchText === keywordRef.current) {
            // 이 코드 중요. 이 전에 부른 키워드의 데이터 값이 늦게 들어올 경우, 제외 시킴
            if (res.data?.foodList?.length > 0) {
              setSearchedFoodLists(res.data.foodList);
              setNoFoodOpen(false);
            } else setNoFoodOpen(true);
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const onChangeKeyEnter = (e) => {
    const key = e.code;
    const keyCode = e.keyCode;
    if (key === "Enter" || keyCode === 13) {
      onSearchForFood();
    }
  };

  const onFocusAction = () => {
    setOpenDialog(true);
    if (boxStatus === "addQty") setBoxStatus("search");
  };

  const handlePhotoBtnClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      console.log("Selected photo:", file);
      setSelectedFile(file);
      setAnalysisResult(null);

      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);

      // AI 분석 시작
      setIsAnalyzing(true);
      dispatch(analyzeFoodImage({ file }))
        .unwrap()
        .then((res) => {
          console.log("Analysis result:", res);
          if (res.ok) {
            setAnalysisResult(res);
            if (!res.isFood) {
              toast(
                <p>음식 사진이 아닌 것 같습니다. 다른 사진을 선택해주세요.</p>,
                toastCommonProps("bottom-center", "toast_alert", 2000)
              );
            }
          } else {
            toast(
              <p>{res.error || "이미지 분석에 실패했습니다."}</p>,
              toastCommonProps("bottom-center", "toast_alert", 2000)
            );
          }
        })
        .catch((err) => {
          console.log("Analysis error:", err);
          toast(
            <p>이미지 분석에 실패했습니다.</p>,
            toastCommonProps("bottom-center", "toast_alert", 2000)
          );
        })
        .finally(() => {
          setIsAnalyzing(false);
        });
    }
  };

  const handleConfirmUpload = () => {
    if (!selectedFile) return;

    setIsUploading(true);
    let params = {
      userId: loginInfo.userId,
      mealDate: mealDate,
      mealType: mealType,
      file: selectedFile
    };

    // AI 분석 결과가 있으면 영양 정보 추가
    if (analysisResult && analysisResult.isFood && analysisResult.totalNutrition) {
      params.kcal = analysisResult.totalNutrition.calories;
      params.proteinG = analysisResult.totalNutrition.protein;
      params.carbohydratesG = analysisResult.totalNutrition.carbohydrate;
      params.fatG = analysisResult.totalNutrition.fat;
      // 추가 영양소
      params.sodiumMG = analysisResult.totalNutrition.sodium;
      params.totalsugarG = analysisResult.totalNutrition.sugar;
      params.totalDietaryfiberG = analysisResult.totalNutrition.dietaryFiber;
      params.cholesterolMG = analysisResult.totalNutrition.cholesterol;
      params.totalSaturatedfattyacidG = analysisResult.totalNutrition.saturatedFat;
      params.transfattyacidG = analysisResult.totalNutrition.transFat;
      // 분석된 음식 목록을 JSON 문자열로 저장
      if (analysisResult.foods && analysisResult.foods.length > 0) {
        params.analyzedFoods = JSON.stringify(analysisResult.foods);
      }
    }

    dispatch(uploadMealImage(params))
      .unwrap()
      .then((res) => {
        if (res.ok) {
          toast(
            <p>식사 사진이 업로드 되었습니다.</p>,
            toastCommonProps("bottom-center", "toast_alert", 1000)
          );
          dispatch(searchWeeklyMeal({ userId: loginInfo.userId, mealDate: mealDate }));
        } else {
          toast(
            <p>{res.error}</p>,
            toastCommonProps("bottom-center", "toast_alert", 1000)
          );
        }
      })
      .catch(err => console.log(err))
      .finally(() => {
        setIsUploading(false);
        handleCancelPreview();
      });
  };

  const handleCancelPreview = () => {
    setPreviewImage(null);
    setSelectedFile(null);
    setAnalysisResult(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    inputRef.current.focus();
    setOpenDialog(true); //다이얼로그 바로 오픈
    dispatch(searchForRecentFood({ userId: loginInfo.userId }));
  }, [dispatch, loginInfo.userId]);

  useEffect(() => {
    window.scrollTo(0, 0);
    const debounce = setTimeout(() => {
      if (value?.length > 0 && value !== setValue) {
        setOpenDialog(true);
        onSearchForFood();
      }
    }, 200);
    keywordRef.current = value;
    return () => clearTimeout(debounce);
    // eslint-disable-next-line
  }, [dispatch, value]);

  return (
    <>
      <div className="flex items-center rounded-xl border border-gray_60 bg-white pb-[18px] pl-3 pt-4">
        <input
          id="foodSearch"
          name="foodSearch"
          ref={inputRef}
          type={"text"}
          onFocus={onFocusAction}
          placeholder={"드신 음식을 입력해주세요."}
          onChange={(e) => {
            boxRef?.current?.scrollIntoView({
              inline: "center",
              behavior: "instant",
            });
            setValue(e.target.value);
          }}
          value={value || ""}
          onKeyDown={onChangeKeyEnter}
          className={
            "h-[64] w-full appearance-none text-body3_500 focus:outline-none focus:ring-0 " +
            (value && boxStatus === "addQty" ? "text-gray_160" : "text-black")
          }
        />
        <label
          onClick={value ? onSearchForFood : null}
          htmlFor="foodSearch"
          className="pr-4"
        >
          <Search className="w-6 h-6" fill={value ? "#0D0D0D" : "#dedede"} />
        </label>
      </div>
      <div className="mt-3">
        <Btn
          active="on"
          title={"사진으로 입력"}
          bgColor={"bg-white"}
          textColor={"text-main font-bold"}
          borderColor={"border border-main"}
          onAction={handlePhotoBtnClick}
        />
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={handleFileChange}
          className="hidden"
        />
      </div>
      {previewImage && (
        <div className="mt-4">
          <div className="overflow-hidden rounded-xl border border-gray_60">
            <img
              src={previewImage}
              alt="미리보기"
              className="h-auto w-full object-contain"
              style={{ maxHeight: "300px" }}
            />
          </div>

          {/* AI 분석 결과 표시 */}
          {isAnalyzing && (
            <div className="mt-3 rounded-xl bg-gray_20 p-4 text-center">
              <p className="text-body3_500 text-gray_160">AI가 음식을 분석하고 있습니다...</p>
            </div>
          )}

          {analysisResult && analysisResult.isFood && (
            <div className="mt-3 rounded-xl bg-blue-50 p-4">
              <p className="mb-2 text-body3_700 text-main">AI 분석 결과</p>
              {analysisResult.foods?.map((food, index) => (
                <div key={index} className="mb-2 rounded-lg bg-white p-3">
                  <p className="text-body3_700">{food.name} ({food.amount})</p>
                  <div className="mt-1 grid grid-cols-4 gap-2 text-caption1_400 text-gray_160">
                    <div className="text-center">
                      <p className="text-caption2_700 text-black">{food.calories}</p>
                      <p>kcal</p>
                    </div>
                    <div className="text-center">
                      <p className="text-caption2_700 text-black">{food.carbohydrate}g</p>
                      <p>탄수화물</p>
                    </div>
                    <div className="text-center">
                      <p className="text-caption2_700 text-black">{food.protein}g</p>
                      <p>단백질</p>
                    </div>
                    <div className="text-center">
                      <p className="text-caption2_700 text-black">{food.fat}g</p>
                      <p>지방</p>
                    </div>
                  </div>
                </div>
              ))}
              {analysisResult.totalNutrition && (
                <div className="mt-2 border-t border-gray_60 pt-2">
                  <p className="text-caption1_700 text-gray_160">총 영양정보</p>
                  <div className="mt-1 grid grid-cols-4 gap-2 text-caption1_400">
                    <div className="text-center">
                      <p className="text-body3_700 text-main">{analysisResult.totalNutrition.calories}</p>
                      <p className="text-gray_160">kcal</p>
                    </div>
                    <div className="text-center">
                      <p className="text-body3_700 text-main">{analysisResult.totalNutrition.carbohydrate}g</p>
                      <p className="text-gray_160">탄수화물</p>
                    </div>
                    <div className="text-center">
                      <p className="text-body3_700 text-main">{analysisResult.totalNutrition.protein}g</p>
                      <p className="text-gray_160">단백질</p>
                    </div>
                    <div className="text-center">
                      <p className="text-body3_700 text-main">{analysisResult.totalNutrition.fat}g</p>
                      <p className="text-gray_160">지방</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

          {analysisResult && !analysisResult.isFood && (
            <div className="mt-3 rounded-xl bg-red-50 p-4 text-center">
              <p className="text-body3_500 text-red-500">
                음식 사진이 아닌 것 같습니다.
                <br />
                다른 사진을 선택해주세요.
              </p>
            </div>
          )}

          <div className="mt-3 flex gap-3">
            <button
              onClick={handleCancelPreview}
              disabled={isUploading || isAnalyzing}
              className="flex-1 rounded-xl border border-gray_100 bg-white py-3 text-body3_700 text-gray_160"
            >
              취소
            </button>
            <button
              onClick={handleConfirmUpload}
              disabled={isUploading || isAnalyzing || (analysisResult && !analysisResult.isFood)}
              className={`flex-1 rounded-xl py-3 text-body3_700 text-white ${
                analysisResult && !analysisResult.isFood ? "bg-gray_100" : "bg-main"
              }`}
            >
              {isUploading ? "업로드 중..." : isAnalyzing ? "분석 중..." : "확인"}
            </button>
          </div>
        </div>
      )}
      <div className="pt-5 text-center text-gray_160">
        <p className="text-caption2_700">
          찾으시는 음식이 없다면,
          <br />
          가장 비슷한 음식을 선택해주세요.
          <br />
          <span className="text-caption2_400 ">
            더 나은 서비스를 위해 계속 업데이트 중입니다.
          </span>
        </p>
      </div>
      <SearchDialog
        boxRef={boxRef}
        boxStatus={boxStatus}
        setBoxStatus={setBoxStatus}
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        keyword={value}
        setValue={setValue}
        onSaveAddorEdit={onSaveAddorEdit}
        noFoodOpen={noFoodOpen}
        setNoFoodOpen={setNoFoodOpen}
        searchedFoodLists={searchedFoodLists}
      />
    </>
  );
};

export default FoodInputBox;
